import React from 'react';
import { FunctionShim } from '@packages/helpers/core/shims/function-shim';
import styles from '../../../styles/widgets/property-portfolio/property-portfolio-total-valuation.module.scss';

const ID = 'property-portfolio-total-valuation';

export const TotalValuation = ({ label, value = 0, format }) => (
  <div className={styles.container}>
    <p id={ID} className={styles.label}>
      {label}
    </p>
    <p role='status' aria-labelledby={ID} className={styles.value}>
      {FunctionShim.isFunction(format) ? format(value) : value}
    </p>
  </div>
);
